import React from 'react';
import styles from './Index.module.css';

const SurveyHeader = ({ studyData }) => {
    return (
        <header className={styles.header}>
            <div className={styles.headerContent}>
                <div className={styles.headerTop}>
                    <h1 className={styles.mainTitle}>{studyData?.title || 'Clinical Study Survey'}</h1>
                    <div className={styles.headerBadge}>
                        <svg className={styles.badgeIcon} viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                        </svg>
                        <span>NIS/2025/27</span>
                    </div>
                </div>
                <p className={styles.headerSubtitle}>
                    Version {studyData?.version || '1.0'} • {studyData?.sections?.length || 0} Sections
                </p>
            </div>
        </header>
    );
};

export default SurveyHeader;